import { render, staticRenderFns } from "./GoogleIcon.vue?vue&type=template&id=f8334c04&"
import script from "./GoogleIcon.vue?vue&type=script&lang=ts&"
export * from "./GoogleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports